module.exports = __webpack_public_path__ + "img/10.78a21474.jpg";